import { DeployEnvironmentEnum, deployEnvironment } from "./deploy";

export const VERSIONE =
  deployEnvironment === DeployEnvironmentEnum.Production ? "" : "d";

export const APP = "web";

export const THUMB_EXT = "thb";

export const MOBILE_WIDTH_BREAKPOINT = 768;
